import { render, staticRenderFns } from "./UpdateOrganizationInfo.vue?vue&type=template&id=65d6d8a0&scoped=true"
import script from "./UpdateOrganizationInfo.vue?vue&type=script&lang=js"
export * from "./UpdateOrganizationInfo.vue?vue&type=script&lang=js"
import style0 from "./UpdateOrganizationInfo.vue?vue&type=style&index=0&id=65d6d8a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d6d8a0",
  null
  
)

export default component.exports